import React from "react";
import { Typography } from "./index";

interface MetricDisplayProps {
  label: string;
  value: string;
  className?: string;
}

const MetricDisplay: React.FC<MetricDisplayProps> = ({
  label,
  value,
  className = "",
}) => (
  <div className={className}>
    <Typography
      variant="p"
      className="text-sm md:text-base text-text-secondary"
    >
      {label}
    </Typography>
    <Typography
      variant="h2"
      className="text-lg md:text-xl font-semibold text-text-primary"
    >
      {value}
    </Typography>
  </div>
);

export default MetricDisplay;
